<template>
  <div class="homepage">
    <!-- 顶部导航 -->
    <header class="header" :class="{ scrolled: isScrolled }">
      <div class="header-container">
        <div class="logo" @click="scrollToSection('hero')">
          <span class="logo-icon">🧺</span>
          <span class="logo-text">星果</span>
        </div>
        <nav class="nav">
          <a @click="scrollToSection('hero')">首页</a>
          <a @click="scrollToSection('features')">产品特色</a>
          <a @click="scrollToSection('about')">关于我们</a>
          <a @click="scrollToSection('contact')">联系我们</a>
          <el-button v-if="!isLoggedIn" type="primary" size="small" @click="goToLogin">
            登录/注册
          </el-button>
        </nav>
      </div>
    </header>

    <!-- Hero主视区 -->
    <section id="hero" class="hero-section">
      <div class="hero-container">
        <div class="hero-content">
          <h1 class="hero-title">星果，书你所想</h1>
          <p class="hero-subtitle">AI驱动的沉浸式互动小说平台</p>
          <p class="hero-desc">让每一个选择都改变故事，让AI记住你的每一次冒险</p>
          <div class="hero-buttons">
            <el-button size="large" @click="scrollToSection('features')">
              了解更多
            </el-button>
          </div>
        </div>
        <div class="hero-image">
          <!-- 图片轮播 -->
          <el-carousel :interval="4000" type="card" height="600px" indicator-position="none" arrow="never">
            <el-carousel-item v-for="(image, index) in carouselImages" :key="index">
              <div class="carousel-image-wrapper">
                <img :src="image" :alt="`应用展示图 ${index + 1}`" @error="handleImageError">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </section>

    <!-- 产品特色 -->
    <section id="features" class="features-section">
      <div class="section-container">
        <h2 class="section-title">产品特色</h2>
        <p class="section-subtitle">CHARACTERISTIC</p>
        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-icon">
              <i class="el-icon-chat-dot-round"></i>
            </div>
            <h3>智能对话系统</h3>
            <p>基于先进AI技术，实现真实的角色互动体验</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <i class="el-icon-notebook-2"></i>
            </div>
            <h3>长期记忆系统</h3>
            <p>AI记住你的每个选择，打造专属的故事线</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <i class="el-icon-share"></i>
            </div>
            <h3>复杂剧情网络</h3>
            <p>支持多章节、多分支的超长故事体验</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="about-section">
      <div class="section-container">
        <h2 class="section-title">关于我们</h2>
        <p class="section-subtitle">ABOUT US</p>
        <div class="about-content">
          <div class="about-text">
            <h3>星果的故事</h3>
            <p>我们是一个由AI工程师、叙事设计师和互动小说作者组成的团队，致力于探索AI与文学的完美结合。</p>
            <p>在星果，我们相信每个人都应该拥有属于自己的独特故事。通过先进的AI技术，我们让虚拟角色不再是冰冷的程序，而是能够理解你、记住你、与你共同成长的伙伴。</p>
            <div class="about-features">
              <div class="about-feature-item">
                <div class="about-icon">🎯</div>
                <div>
                  <h4>我们的使命</h4>
                  <p>让每个人都能创造和体验独一无二的互动故事</p>
                </div>
              </div>
              <div class="about-feature-item">
                <div class="about-icon">💡</div>
                <div>
                  <h4>我们的愿景</h4>
                  <p>成为全球领先的AI互动叙事平台</p>
                </div>
              </div>
              <div class="about-feature-item">
                <div class="about-icon">⚡</div>
                <div>
                  <h4>我们的优势</h4>
                  <p>深度学习技术 + 专业叙事能力 = 极致体验</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="contact-section">
      <div class="section-container">
        <h2 class="section-title">联系我们</h2>
        <p class="section-subtitle">CONTACT US</p>
        <div class="contact-content">
          <div class="contact-info">
            <div class="contact-item">
              <i class="el-icon-service"></i>
              <div>
                <h4>请联系我们官方邮箱</h4>
                <p>xingyuwanxiang@126.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-links">
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
            京ICP备2025135199号-1
          </a>
          <span class="separator">|</span>
          <a @click="goToPrivacy" style="cursor: pointer;">
            隐私政策
          </a>
        </div>
        <div class="footer-copyright">
          <p>主办单位：北京星域万象科技有限公司</p>
          <p>&copy; 2025 星果. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<style scoped lang="scss">
.homepage {
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  color: #333;
  background: #fff;
  scroll-behavior: smooth;
  overflow-x: hidden;
}

/* ========== 顶部导航 ========== */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  transition: all 0.3s ease;

  &.scrolled {
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
  }
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
  }

  .logo-icon {
    font-size: 32px;
    line-height: 1;
  }

  .logo-text {
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
}

.nav {
  display: flex;
  align-items: center;
  gap: 36px;

  a {
    color: #666;
    text-decoration: none;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;

    &:hover {
      color: #6366f1;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 50%;
      transform: translateX(-50%) scaleX(0);
      width: 100%;
      height: 2px;
      background: #6366f1;
      transition: transform 0.3s;
    }

    &:hover::after {
      transform: translateX(-50%) scaleX(1);
    }
  }
}

/* ========== Hero主视区 ========== */
.hero-section {
  padding: 140px 40px 100px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 600px;
  display: flex;
  align-items: center;
}

.hero-container {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.hero-content {
  text-align: left;

  .hero-title {
    font-size: 52px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 24px;
    line-height: 1.2;
  }

  .hero-subtitle {
    font-size: 26px;
    color: #5a6c7d;
    margin-bottom: 20px;
    font-weight: 500;
  }

  .hero-desc {
    font-size: 18px;
    color: #7f8c8d;
    margin-bottom: 48px;
    line-height: 1.8;
  }

  .hero-buttons {
    display: flex;
    gap: 24px;
  }
}

.hero-image {
  width: 100%;
  max-width: 100%;

  :deep(.el-carousel) {
    border-radius: 12px;
    overflow: visible;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  }

  :deep(.el-carousel__item) {
    transition: all 0.5s ease;
    opacity: 0.6;
    transform: scale(0.85);

    &.is-active {
      opacity: 1;
      transform: scale(1);
    }
  }

  .carousel-image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
    border-radius: 12px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .placeholder-content {
      text-align: center;
      color: #95a5a6;

      i {
        font-size: 64px;
        margin-bottom: 16px;
        display: block;
      }

      p {
        font-size: 16px;
        margin: 0;
        font-weight: 500;
      }
    }
  }
}


/* ========== 通用区块样式 ========== */
.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 40px;
}

.section-title {
  font-size: 42px;
  font-weight: bold;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 12px;
}

.section-subtitle {
  font-size: 14px;
  color: #95a5a6;
  text-align: center;
  letter-spacing: 3px;
  margin-bottom: 80px;
  text-transform: uppercase;
}

/* ========== 产品特色 ========== */
.features-section {
  background: #fff;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 50px;
}

.feature-item {
  text-align: center;
  padding: 40px 30px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
  }

  .feature-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    border-radius: 50%;
    transition: all 0.3s ease;

    i {
      font-size: 48px;
      color: #fff;
    }
  }

  &:hover .feature-icon {
    transform: scale(1.1) rotate(5deg);
  }

  h3 {
    font-size: 22px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 16px;
  }

  p {
    font-size: 15px;
    color: #7f8c8d;
    line-height: 1.8;
    padding: 0 10px;
  }
}

/* ========== 关于我们 ========== */
.about-section {
  background: #f8f9fa;
}

.about-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.about-text {
  h3 {
    font-size: 32px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 32px;
  }

  > p {
    font-size: 17px;
    color: #5a6c7d;
    line-height: 2;
    margin-bottom: 20px;
    text-align: justify;
  }
}

.about-features {
  margin-top: 60px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.about-feature-item {
  text-align: center;
  padding: 30px 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  .about-icon {
    font-size: 48px;
    margin-bottom: 20px;
    display: block;
  }

  h4 {
    font-size: 20px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 12px;
  }

  p {
    font-size: 15px;
    color: #7f8c8d;
    line-height: 1.6;
    margin: 0;
  }
}

/* ========== 联系我们 ========== */
.contact-section {
  background: #fff;
}

.contact-content {
  max-width: 700px;
  margin: 0 auto;
}

.contact-info {
  display: flex;
  justify-content: center;
  gap: 80px;
  flex-wrap: wrap;
}

.contact-item {
  text-align: center;
  flex: 0 0 auto;
  min-width: 200px;

  i {
    font-size: 56px;
    color: #409eff;
    margin-bottom: 20px;
    display: block;
  }

  h4 {
    font-size: 20px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 12px;
  }

  p {
    font-size: 15px;
    color: #7f8c8d;
    margin: 0;
  }
}

/* ========== 底部 ========== */
.footer {
  background: #2c3e50;
  padding: 50px 40px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  a {
    color: #ecf0f1;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s;

    &:hover {
      color: #6366f1;
    }
  }

  .separator {
    color: #95a5a6;
    font-size: 14px;
  }
}

.footer-copyright {
  p {
    color: #95a5a6;
    font-size: 13px;
    margin: 10px 0;
    line-height: 1.6;
  }
}

/* ========== 响应式设计 ========== */
@media (max-width: 1024px) {
  .header-container,
  .section-container {
    padding-left: 30px;
    padding-right: 30px;
  }

  .hero-section {
    padding: 120px 30px 80px;
  }

  .hero-container {
    grid-template-columns: 1fr;
    gap: 60px;
  }

  .hero-content {
    text-align: center;

    .hero-buttons {
      justify-content: center;
    }
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .about-features {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .contact-info {
    flex-direction: column;
    align-items: center;
    gap: 50px;
  }
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 20px;
  }

  .nav {
    gap: 20px;

    a {
      font-size: 14px;
    }
  }

  .hero-section {
    padding: 100px 20px 60px;
  }

  .hero-content {
    .hero-title {
      font-size: 36px;
    }

    .hero-subtitle {
      font-size: 20px;
    }

    .hero-desc {
      font-size: 16px;
    }

    .hero-buttons {
      flex-direction: column;
      gap: 16px;
    }
  }

  .hero-image {
    :deep(.el-carousel) {
      height: 400px !important;
    }
  }

  .section-container {
    padding: 60px 20px;
  }

  .section-title {
    font-size: 32px;
  }

  .section-subtitle {
    margin-bottom: 50px;
  }

  .feature-item {
    padding: 30px 20px;

    .feature-icon {
      width: 80px;
      height: 80px;

      i {
        font-size: 40px;
      }
    }

    h3 {
      font-size: 20px;
    }

    p {
      font-size: 14px;
    }
  }

  .about-text {
    h3 {
      font-size: 26px;
    }

    > p {
      font-size: 15px;
    }
  }

  .footer {
    padding: 40px 20px;
  }
}

@media (max-width: 480px) {
  .logo .logo-text {
    font-size: 20px;
  }

  .nav {
    display: none;
  }

  .hero-content .hero-title {
    font-size: 28px;
  }

  .section-title {
    font-size: 26px;
  }
}
</style>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router/composables'

const router = useRouter()

// 检查登录状态
const isLoggedIn = computed(() => !!localStorage.getItem('TOKEN'))

// 滚动状态
const isScrolled = ref(false)

// 轮播图片列表
const carouselImages = ref([
  '/static/1.png',
  '/static/2.png',
  '/static/3.png'
])

// 处理图片加载错误（如果图片不存在，显示占位符）
const handleImageError = (event: Event) => {
  const target = event.target as HTMLImageElement
  // 使用占位符
  target.style.display = 'none'
  if (target.parentElement) {
    target.parentElement.style.background = '#f5f7fa'
    target.parentElement.innerHTML += '<div class="placeholder-content" style="color: #95a5a6;"><i class="el-icon-picture-outline"></i><p>应用展示图</p></div>'
  }
}

// 处理滚动事件
const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}

// 页面滚动到指定区域
const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId)
  if (element) {
    const offset = 70 // header高度
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}

// 导航方法
const goToLogin = () => {
  router.push('/login')
}

const goToPrivacy = () => {
  router.push('/privacy')
}

// 生命周期
onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>